import { type UserRole } from '../types/UserRole';

const RolesDictionary: Record<UserRole, string> = Object.freeze({
  'InMotion.Admin': 'Admin',
  'InMotion.ContentManager': 'Content manager',
  'InMotion.OrganizationManager': 'Organization manager',
  'InMotion.Viewer': 'Viewer',
});

export default RolesDictionary;
